import React from "react";
import { GraduationCap, Briefcase, Home, Users } from "lucide-react";

const CANDIDATE_IMG =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_bold-davinci-9/artifacts/35v4gcri_Screenshot%202026-07-26%20at%2011.06.08%E2%80%AFAM.webp";

const highlights = [
  { icon: GraduationCap, title: "Education", text: "SUNY Oswego (History) & Syracuse University (MPA)" },
  { icon: Briefcase, title: "Experience", text: "45-year career in municipal finance" },
  { icon: Home, title: "Oswego Roots", text: "Grew up in Oswego \u2014 St. Mary\u2019s, Oswego Catholic High" },
  { icon: Users, title: "Family", text: "Three grown daughters and four grandchildren" },
];

const About = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="relative flex justify-center">
            <div className="relative w-full max-w-md">
              <div className="absolute -top-6 -left-6 w-40 h-40 star-field rounded-2xl opacity-90 hidden md:block" />
              <div className="absolute -bottom-6 -right-6 w-40 h-24 flag-stripes rounded-2xl opacity-90 hidden md:block" />
              <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-slate-100">
                <img
                  src={CANDIDATE_IMG}
                  alt="Gregory A. Clark"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#b22234] font-bold mb-4">
              About the Candidate
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl font-extrabold text-[#0a3161] leading-tight">
              Meet Gregory Clark
            </h2>
            <div className="mt-6 h-1 w-20 bg-[#b22234] rounded-full" />

            <div className="mt-8 space-y-6 text-[#1f2a44] text-[21px] leading-[1.8]">
              <p>
                Greg Clark grew up in Oswego and graduated from St. Mary&rsquo;s School, Oswego
                Catholic High, and SUNY Oswego, where he majored in history and was a member of
                Sigma Tau Chi Fraternity. During this time Greg also worked at various Oswego
                businesses, including Nunzi&rsquo;s Grill, Lupe&rsquo;s Sports Shop, and Papertronics.
              </p>
              <p>
                After he graduated from Oswego State, Greg attended Syracuse University, where he
                earned a master&rsquo;s degree in public administration. That prepared Greg for a
                45-year career in municipal finance. On a daily basis Greg studied cities, counties,
                and other governments and learned what makes them financially sound and economically
                successful.
              </p>
              <p>
                Greg and his wife MaryJo, a registered nurse and Oswego native, returned to live in
                Oswego three years ago to be closer to friends and family. Greg and MaryJo have
                three grown daughters and four grandchildren.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 mt-10">
              {highlights.map((h) => (
                <div
                  key={h.title}
                  className="lift flex items-start gap-4 p-5 rounded-xl border border-slate-200 bg-white"
                >
                  <div className="w-11 h-11 rounded-lg bg-[#0a3161]/5 flex items-center justify-center text-[#0a3161] shrink-0">
                    <h.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <div className="font-semibold text-[#0a3161] text-sm">{h.title}</div>
                    <div className="text-[13.5px] text-slate-600 leading-snug mt-0.5">{h.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
